module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_63.bc7c78b4.jpg";